import { Session } from '/app/utils/auth';
import { defineAppRouteMiddleware } from '/app/utils/app';
import { markSignupPending } from '/app/utils/signup-tracking';

export default defineAppRouteMiddleware((to) => {
    // accounts.bignerve.com appends `signup=1` when returning from registration.
    // Remember it for the "Signup Completed" event, then drop it from the URL
    // (the redirect re-enters this middleware to handle `token`).
    if (to.query.signup) {
        markSignupPending();

        const query = { ...to.query };
        delete query.signup;

        return {
            ...to,
            query,
            replace: true
        };
    }

    // check if shadow mode is enabled
    if (to.query.token && (to.query.mode === 'shadow' || to.query.shadow)) {
        Session.startShadow(to.query.token);

        const query = { ...to.query };
        delete query.mode;
        delete query.shadow;
        delete query.token;

        return {
            ...to,
            query,
            replace: true
        };
    }
    else if (to.query.token && to.query.mode === 'staff') {
        Session.startStaff(to.query.token);

        const query = { ...to.query };
        delete query.token;
        delete query.mode;

        return {
            ...to,
            query,
            replace: true
        };
    }
    // set new token
    else if (to.query.token) {
        Session.setToken(to.query.token);

        const query = { ...to.query };
        delete query.token;

        return {
            ...to,
            query,
            replace: true
        };
    }
})